export const instruments = ["s-aapl"];
export const instrumentsForList = [
    "c-eur-usd",
    "c-usd-jpy",
    "c-gbp-usd",
    "c-usd-chf",
    "c-usd-cad",
    "c-aud-usd",
    "c-gbp-jpy",
    "co-natural-gas",
    "co-gold",
    "co-silver",
    "co-wti-crude-oil",
    "co-brent-crude-oil",
    "co-wheat",
    "co-copper",
    "co-corn",
    "cc-bitcoin",
    "cc-ethereum",
    "cc-ripple",
    "cc-cardano",
    "cc-solana",
    "cc-dogecoin",
    "cc-shiba-inu",
    "i-spx",
    "i-vix",
    "i-us30-usd",
    "i-nas100-usd",
    "i-eu50-eur",
    "i-uk100-gbp",
    "i-de30-eur",
    "i-hk33-hkd",
    "s-aapl",
    "s-msft",
    "s-goog",
    "s-amzn",
    "s-meta",
    "s-nflx",
    "s-tsla",
    "e-spy",
    "e-gld",
    "e-iemg",
    "e-xlp",
    "e-slv",
    "e-qqq",
    "e-soxx",
    "e-uso"
];
